<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <div class="notice">
        <p>
          <i class="el-alert__icon el-icon-warning"></i>
          {{notice}}
        </p>
      </div>
      <el-form ref="form" class="mt20" :model="formdata" label-width="80px">
        <el-form-item label="商品分类:">
          <el-cascader
            :options="cateoptions"
            expand-trigger="hover"
            v-model="formdata.cat_id"
            :props="defaultprops"
            change-on-select
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
export default {
  name: "chooseClassifyDialog",
  props: ["visible", "ids", "type", "flag"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      title: this.type === "M" ? "批量转移分类" : "批量添加到分类",
      notice:
        this.type === "M"
          ? "本操作将删除原分类归属，并添加到所选分类下。"
          : "本操作保留原分类归属，并新增到所选分类下。",
      defaultprops: {
        value: "id",
        label: "name",
        children: "child"
      },
      dialogVisible: this.visible,
      formdata: {
        cat_id: []
      },
      cateoptions: []
    };
  },
  created() {
    this.notice =
      this.type === "M"
        ? "本操作将删除原分类归属，并添加到所选分类下。"
        : "本操作保留原分类归属，并新增到所选分类下。";
    this.title = this.type === "M" ? "批量转移分类" : "批量添加到分类";
    this.querycatelist();
  },
  methods: {
    // 查询分类
    querycatelist() {
      let params = {};
      this.axios
        .post(api[`${this.flag}_goods_cate_list`], params)
        .then(response => {
          if (response.data.code == 0) {
            this.cateoptions = this.translatecate(response.data.list || []);
          } else {
          }
        })
        .catch(() => {});
    },
    // 转换分类数据
    translatecate(data) {
      if (data && data.length) {
        data.forEach(item => {
          if (item.child && item.child.length) {
            item.child = this.translatecate(item.child);
          } else {
            item.child = null;
          }
        });
      }
      return data;
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var url = api[`${this.flag}_add_to_cate`];
          var msg = "批量添加分类成功";
          if (this.type == "M") {
            url =  api[`${this.flag}_move_to_cate`];
            msg = "批量转移分类成功";
          }
          this.submitsave(url, msg);
        } else {
          return false;
        }
      });
    },
    // 提交保存 批量添加到分类
    submitsave(url, msg) {
      let params = {
        id: this.ids,
        cat_id: this.formdata.cat_id[this.formdata.cat_id.length - 1]
      };
      this.axios
        .post(url, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$emit("success");
            this.$message({
              message: msg,
            });
            this.dialogVisible = false;
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>

